/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1TransactionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_TRANSACTION_EVENT_ENTITY_NAME = 'ixf.accounting.v1.TransactionEvent';
export const ixfAccountingV1TransactionEventEntity = new schema.Entity<IxfAccountingV1TransactionEvent>(IXF_ACCOUNTING_V1_TRANSACTION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfAccountingV1TransactionEvent) => `${entity.metadata?.eventId}` });

